import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {
  Button,
  Icon,
  Field,
  Form,
  Popup,
  Picker,
  List,
  Overlay,
  Image as VanImage,
  Dialog,
  Toast,
  Lazyload,
} from 'vant'

// animate.css
import 'animate.css'
import { animateCSS, isFangCheBaoApp, sendLog } from '@/utils'

// 公共组件
import Header from '@/components/Header'

// 实例方法
import request from '@/utils/request'

// 公共方法
import * as funs from './globalFun'

// 全局minin
import mixin from '@/mixin'

// 非恒驰App启用mock数据
import '../mock/hcApp/HCAppNative'

// 复制插件
import VueClipboard from 'vue-clipboard2'

import '@/utils/security'
import '@/utils/initWxConfig'
import '@/utils/selfAdapt'

const app = createApp(App).use(store).use(router)
app
  .use(Button)
  .use(Icon)
  .use(Field)
  .use(Form)
  .use(Popup)
  .use(Picker)
  .use(List)
  .use(Overlay)
  .use(VanImage)
  .use(Dialog)
  .use(Lazyload)
app.use(VueClipboard)
app.config.globalProperties.$animateCSS = animateCSS
app.config.globalProperties.$request = request
app.config.globalProperties.$toast = Toast
Object.keys(funs).forEach((key) => {
  app.config.globalProperties[key] = funs[key]
})
app.component('Header', Header)
app.mixin(mixin)

/** 错误日志收集 */
window.addEventListener(
  'error',
  (error) => {
    sendLog({
      type: error.type,
      url: location.href,
      userAgent: navigator.userAgent,
      isTrusted: error.isTrusted,
      message: error.message || error.error?.message,
      stack: error.error?.stack,
      token: store.state?.userInfo?.acpToken,
    })
  },
  true
)

window.addEventListener('unhandledrejection', function (evt) {
  sendLog({
    type: evt.type,
    url: location.href,
    userAgent: navigator.userAgent,
    isTrusted: evt.isTrusted,
    message: evt.reason?.message,
    stack: evt.reason?.stack,
    ...evt.reason,
    token: store.state?.userInfo?.acpToken,
  })
})

// 上报错误日志
app.config.errorHandler = function (err, vm, info) {
  if (err?.name) {
    sendLog({
      type: err.name,
      message: err.message,
      stack: err.stack,
      url: location.href,
      userAgent: navigator.userAgent,
      info: info,
      token: store.state?.userInfo?.acpToken,
    })
  }
  console.error(err)
}
// 种房车宝标志
isFangCheBaoApp()

app.mount('#app')
